import React, { useState } from 'react';
import { XIcon, AlertTriangleIcon } from 'lucide-react';
import { toast } from 'sonner';
interface DeleteAccountModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function DeleteAccountModal({
  isOpen,
  onClose
}: DeleteAccountModalProps) {
  const [confirmText, setConfirmText] = useState('');
  if (!isOpen) return null;
  const handleDelete = () => {
    if (confirmText !== 'DELETE') {
      toast.error('Type DELETE to confirm');
      return;
    }
    toast.success('Account deletion request submitted');
    setConfirmText('');
    onClose();
  };
  return <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4" role="dialog" aria-modal="true" data-id="element-761" data-mp="24imvczhahm6t">
      <div className="bg-white w-full max-w-md rounded-xl shadow-xl overflow-hidden" data-id="element-762" data-mp="1zja6k96uy51l">
        <div className="flex items-center justify-between p-5 border-b border-gray-200" data-id="element-763" data-mp="t4j25vij022t">
          <h2 className="text-lg font-bold text-gray-900" data-id="element-764" data-mp="o3litfls51zq">Delete Account</h2>
          <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-gray-100" aria-label="Close" data-id="element-765" data-mp="3076wdp77b0e6">
            <XIcon className="w-5 h-5" data-id="element-766" data-mp="3561mzdbett8u" />
          </button>
        </div>
        <div className="p-5 space-y-4" data-id="element-767" data-mp="2q8isduc1wlth">
          <div className="flex items-start gap-3 p-4 bg-red-50 border border-red-200 rounded-lg" data-id="element-768" data-mp="2qbn55g3l0pvr">
            <AlertTriangleIcon className="w-5 h-5 text-red-600 mt-0.5 flex-shrink-0" data-id="element-769" data-mp="2vaq4ql0sm3wc" />
            <p className="text-sm text-red-800" data-id="element-770" data-mp="2hfxlpclp25l0">
              This action is permanent and cannot be undone. All your orders,
              addresses, and saved data will be permanently deleted.
            </p>
          </div>
          <div data-id="element-771" data-mp="2ci5j9onfb12k">
            <label className="text-sm font-medium text-gray-700" data-id="element-772" data-mp="2chmaaxfr3n0o">
              Type <span className="font-bold" data-id="element-773" data-mp="2cft0j99ucmog">DELETE</span> to confirm
            </label>
            <input type="text" value={confirmText} onChange={e => setConfirmText(e.target.value)} className="mt-1 w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600" data-id="element-774" data-mp="1ykh8j9n2lab8" />
          </div>
          <div className="flex gap-3 pt-2" data-id="element-775" data-mp="48fwlzyf0no1">
            <button type="button" onClick={onClose} className="flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50" data-id="element-776" data-mp="3vg25c6zzrgbr">
              Cancel
            </button>
            <button type="button" onClick={handleDelete} className="flex-1 px-4 py-2.5 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700" data-id="element-777" data-mp="rxqwlf7xye14">
              Delete Account
            </button>
          </div>
        </div>
      </div>
    </div>;
}